module.exports = __webpack_public_path__ + "static/media/icon_account.1b8d8aab.svg";